import React from 'react';
import PropTypes from 'prop-types';
import messages from './messages';
import { Icon } from 'antd';

import './item.scss';
import 'antComponentsStyle';

const item = (props) => {
  const { text, code, symbol, price, unit, callback } = props;

  return (
    <li
      className="Interactive-List-item"
      onClick={ () => callback(code) }
      title={messages.removeItem.defaultMessage}
    >
      <span className={'item-content'}>
        <Icon type="close" />&nbsp;
        {text}
      </span>
      <span className="float-right price">
        {symbol} <strong>{price}</strong>&nbsp;{unit}
      </span>
    </li>
  );
};


item.defaultProps = {
  symbol: '',
  unit: '€',
  callback: () => {},
};

item.propTypes = {
  text: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  symbol: PropTypes.string,
  unit: PropTypes.string,
  price: PropTypes.number.isRequired,
  callback: PropTypes.func,
};

export default item;
